import { render, staticRenderFns } from "./loan-type-card.vue?vue&type=template&id=174d3700&scoped=true"
import script from "./loan-type-card.vue?vue&type=script&lang=js"
export * from "./loan-type-card.vue?vue&type=script&lang=js"
import style0 from "./loan-type-card.vue?vue&type=style&index=0&id=174d3700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174d3700",
  null
  
)

export default component.exports